/*
 * @prop selectedOption: (required) an Object of { value: $value, label: $label } for the current selected option. set to null if no option is selected
 * @prop options: (required) an Array of { value: $value, label: $label } for rendering and searching
 * @prop onOptionSelected(option): (required) a function callback to handle selected option(s)
 * @prop multi: (optional) a boolean to turn on/off multi selection
 * @prop autofocus: (optional) a boolean to turn on/off autofocus on the component upon mounting
 * @prop searchable: (optional) a boolean to enable/disable search
 * @prop clearable: (optional) a boolean to enable/disable clearing
 * @prop placeholder: (optional) a string to show when no option is selected
 */

import React from 'react'
import Select from 'react-select'

import 'react-select/dist/react-select.css'

class SearchBar extends React.Component {
  render() {
    const { 
      selectedOption, 
      options, 
      multi, 
      autofocus, 
      searchable = true, 
      clearable, 
      placeholder, 
      disabled, 
    } = this.props

    return (
      <Select
        menuContainerStyle={{ zIndex: 999 }}
        value={selectedOption}
        options={options}
        multi={multi ? multi : false}
        autoFocus={autofocus ? autofocus : false}
        searchable={searchable}
        clearable={clearable ? clearable : true}
        placeholder={placeholder ? placeholder : 'Select ...'}
        onChange={this.props.onOptionSelected}
        onInputKeyDown={this.props.onInputKeyDown}
        onInputChange={this.props.onInputChange}
        disabled={disabled}
      />
    )
  }
}

export default SearchBar



// WEBPACK FOOTER //
// ./src/components/UI/SearchBar.js